const Footer = () => {
    return <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 border-top">
        <div className="container">
            <p className="main-blue py-3 text-center">@ CursoReact.es</p>
        </div>
    </footer>
}

export default Footer;